import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/mobile/alarms/pagination',
    method: 'get',
    params
  })
}
